import { useApiSubmit } from '@hooks/use-api-submit';
import type { IApiSubmitResultBase } from '@/types/api';

const PWL_JUG_SELF_ENDPOINT = '/api/register/pwl-jug-self';

export const usePwlJugSelf = (registrationId: number, editKey: string) => {
    const url = `${PWL_JUG_SELF_ENDPOINT}/${registrationId}/${editKey}`;

    const { submit, isSubmitting, submitError } = useApiSubmit<void, unknown, IApiSubmitResultBase>(
        url,
        () => ({}),
        () => ({}),
        'We were not able to record your response. Please try again.',
    );

    return { confirm: submit, isConfirming: isSubmitting, error: submitError };
};
